import { render, staticRenderFns } from "./successMsg.vue?vue&type=template&id=8b9d3850&scoped=true&"
import script from "./successMsg.vue?vue&type=script&lang=js&"
export * from "./successMsg.vue?vue&type=script&lang=js&"
import style0 from "./successMsg.vue?vue&type=style&index=0&id=8b9d3850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9d3850",
  null
  
)

component.options.__file = "successMsg.vue"
export default component.exports